Mimics HTML from WP so that classes from _magazine.scss are applicable
<template>
    <div class="post-group__item">
        <LocalizedLink :to="getPostRoute(post.slug)">
            <div class="post-group__item-image-wrap">
                <img :src="post.imageUrl" :alt="post.imageAltText" class="post-group__item-image" />
            </div>
        </LocalizedLink>
        <div class="post-group__item-body">
            <div v-if="showMeta" class="post-group__item-meta">
                <span v-if="settings.show_author" class="post-group__item-author">{{ post.author }}</span>
                <span v-if="settings.show_date" class="post-group__item-date">{{ post.date }}</span>
            </div>
            <div v-if="terms.length > 0" class="post-group__item-terms">
                <LocalizedLink v-for="(term, i) in terms" :key="`term-${i}`" :to="term.route">
                    {{ term.title }}
                </LocalizedLink>
            </div>

            <h3 class="post-group__item-title">
                <LocalizedLink :to="getPostRoute(post.slug)">
                    {{ post.title }}
                </LocalizedLink>
            </h3>
            <div class="post-group__item-excerpt">{{ post.excerpt }}</div>
        </div>
    </div>
</template>

<script>
import magazineHelpersMixin from '~/mixins/magazineHelpersMixin';

export default {
    mixins: [magazineHelpersMixin],
    props: {
        post: {
            type: Object,
            required: true,
        },
        settings: {
            type: Object,
            default: () => ({
                show_author: true,
                show_date: true,
                show_cat: true,
                show_tags: true,
            }),
        },
    },
    computed: {
        showMeta() {
            return this.settings.show_author || this.settings.show_date;
        },
        terms() {
            let terms = [];

            if (this.settings.show_cat && this.post.categoryTitle) {
                terms.push({
                    title: this.post.categoryTitle,
                    route: this.getCategoryRoute(this.post.categorySlug),
                });
            }

            if (this.settings.show_tags && this.post.tags) {
                const tags = this.post.tags.map(tag => {
                    return {
                        ...tag,
                        route: this.getTagRoute(tag.slug),
                    };
                });

                terms = [...terms, ...tags];
            }

            return terms;
        },
    },
};
</script>
